import React, { useContext, useCallback } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NonAuthRoutes, RouteParamsTypes, Modules } from '../enums';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import PublicLayout from '../components/Layout/Public';
import Login from '../modules/auth/login';
import MfaVerify from '../modules/auth/mfa-verify';
import Activate from '../modules/auth/activate';
import ActivateTenantUser from '../modules/auth/activateTenantUser';

const Auth: React.FC = () => {
  const { token, permissions, isSystemAdmin } = useContext(AuthContext);

  const handleBlankRoute = useCallback(() => {
    if (token) {
      return (
        redirectBasedOnPermission(isSystemAdmin, permissions) ||
        Modules.error + NonAuthRoutes.forbidden
      );
    } else {
      return Modules.auth + NonAuthRoutes.login;
    }
  }, [token, isSystemAdmin, permissions]);

  return (
    <Routes>
      <Route
        path={NonAuthRoutes.login}
        element={<PublicLayout route={NonAuthRoutes.login} children={<Login />} />}
      />
      <Route
        path={NonAuthRoutes.mfaVerify}
        element={<PublicLayout route={NonAuthRoutes.mfaVerify} children={<MfaVerify />} />}
      />
      <Route
        path={NonAuthRoutes.activate}
        element={<PublicLayout route={NonAuthRoutes.activate} children={<Activate />} />}
      />
      <Route
        path={NonAuthRoutes.activateTenantUser}
        element={<PublicLayout route={NonAuthRoutes.activateTenantUser} children={<ActivateTenantUser />} />}
      />
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: handleBlankRoute() }} />}
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Auth;
